import * as React from 'react';
import { App } from '@app/src/views';
import { Login } from '@app/src/views/Login/login';
import { CreatePassword } from '@app/src/views/Login/createPassword';
import { CipGeneration } from '@app/src/views/CipGeneration';
import { CipReport } from '@app/src/views/CipReport';
import { Users } from '@app/src/views/Users';
import { CreateUsers } from '@app/src/views/CreateUsers';
import { EditUsers } from '@app/src/views/EditUser';

const NotFound: React.FC<{}> = () => (
  <>NotFound</>
);

export const routes = [
  {
    component: App,
    routes: [
      {
        path: '/',
        component: Login,
        exact: true
      },
      {
        path: '/actualizarcontrasena/:token',
        component: CreatePassword,
        exact: true
      },
      {
        path: '/generarcip',
        component: CipGeneration,
        exact: true
      },
      {
        path: '/reportecip',
        component: CipReport,
        exact: true
      },
      {
        path: '/usuarios',
        component: Users,
        exact: true
      },
      {
        path: '/usuarios/crear',
        component: CreateUsers,
        exact: true
      },
      {
        path: '/usuarios/editar',
        component: EditUsers,
        exact: true
      },
      {
        path: '*',
        component: NotFound
      }
    ]
  }
]
